import React from 'react';
import { Helmet } from 'react-helmet-async';

// Shared SEO / <head> component for V-Tech Industries.
// Also loads the site fonts so any page rendering <HelmetAsync/> gets them.
export const HelmetAsync = ({ title, description, keywords, url, body }) => {
  const pageTitle = title ?? 'V-Tech Industries';
  const pageDesc = description ?? 'V-tech Industries is a Gurugram based manufacturer of industrial brush, CBN & diamond honing stones, honing mandrels and fixtures.';
  const pageKeys = keywords ?? 'V-Tech Industries, vtech gurugram';
  const path = url ?? '/';
  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDesc} />
      <meta name="keywords" content={pageKeys} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDesc} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={pageDesc} />
      <body className={body} />
      <link rel="canonical" href={`https://v-tech.co.in` + path} />
      <meta property="og:url" content={`https://v-tech.co.in` + path} />

      {/* Fonts used across the site */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link
        href="https://fonts.googleapis.com/css2?family=Archivo:wght@500;600;700;800;900&family=IBM+Plex+Sans:wght@400;500;600&display=swap"
        rel="stylesheet"
      />
    </Helmet>
  );
};

export default HelmetAsync;
